export const formataPorcentagem = (value) => {
  const numeroFormat = Number(value);
  return numeroFormat.toString().replace('.', ',') + '%';
};
